import Vue from 'vue';
import VueNumeralFilter from 'vue-numeral-filter';

Vue.use(VueNumeralFilter, {locale: 'no'});


// import helpers from "@/plugins/helpers.mixin.js";
//
// Vue.mixin(helpers);
